import { render, staticRenderFns } from "./PreferredDepartment.vue?vue&type=template&id=a38de3b6&scoped=true"
import script from "./PreferredDepartment.vue?vue&type=script&lang=js"
export * from "./PreferredDepartment.vue?vue&type=script&lang=js"
import style0 from "./PreferredDepartment.vue?vue&type=style&index=0&id=a38de3b6&prod&lang=scss"
import style1 from "./PreferredDepartment.vue?vue&type=style&index=1&id=a38de3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38de3b6",
  null
  
)

export default component.exports